import "./src/styles/global.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
require("prismjs/themes/prism-tomorrow.css");
